import './Message.css'

function Message({ message }) {
  const { role, content, timestamp } = message
  const isAssistant = role === 'assistant'

  // Format timestamp
  const formatTime = (ts) => {
    if (!ts) return null
    const date = new Date(ts)
    return date.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })
  }

  // Simple markdown-like formatting
  const formatContent = (text) => {
    if (!text) return null

    // Split by code blocks first
    const parts = text.split(/(```[\s\S]*?```)/g)

    return parts.map((part, index) => {
      // Handle code blocks
      if (part.startsWith('```') && part.endsWith('```')) {
        const code = part.slice(3, -3).replace(/^\w+\n/, '') // Remove language identifier
        return (
          <pre key={index} className="code-block">
            <code>{code}</code>
          </pre>
        )
      }

      // Handle regular text with inline formatting
      return (
        <span key={index}>
          {part.split('\n').map((line, lineIndex, arr) => {
            // Handle headings
            const headingMatch = line.match(/^(#{1,6})\s+(.+)$/)
            if (headingMatch) {
              const level = headingMatch[1].length
              const text = headingMatch[2]
              const HeadingTag = `h${level}`
              return <HeadingTag key={lineIndex} className={`markdown-h${level}`}>{formatLineInner(text)}</HeadingTag>
            }

            // Handle horizontal rules
            if (line.match(/^(-{3,}|_{3,}|\*{3,})$/)) {
              return <hr key={lineIndex} className="markdown-hr" />
            }

            return (
              <span key={lineIndex}>
                {formatLine(line)}
                {lineIndex < arr.length - 1 && <br />}
              </span>
            )
          })}
        </span>
      )
    })
  }

  // Format inline markdown (bold, italic, code, links)
  const formatInlineMarkdown = (text) => {
    let result = text
    // Bold text
    result = result.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
    // Italic text
    result = result.replace(/\*(.+?)\*/g, '<em>$1</em>')
    // Inline code
    result = result.replace(/`(.+?)`/g, '<code class="inline-code">$1</code>')
    // Links
    result = result.replace(/\[(.+?)\]\((.+?)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>')
    return result
  }

  const formatLine = (line) => {
    return <span dangerouslySetInnerHTML={{ __html: formatInlineMarkdown(line) }} />
  }

  const formatLineInner = (text) => {
    return <span dangerouslySetInnerHTML={{ __html: formatInlineMarkdown(text) }} />
  }

  // Don't show timestamp for welcome/system message
  const showTimestamp = timestamp && message.id !== 'welcome'

  return (
    <div className={`message message-${role}`}>
      <div className="message-bubble">
        <div className="message-content">
          {formatContent(content)}
          {isAssistant && !content && (
            <span className="streaming-cursor" />
          )}
        </div>
        {showTimestamp && (
          <span className="message-timestamp">{formatTime(timestamp)}</span>
        )}
      </div>
    </div>
  )
}

export default Message
